import React, { FormEvent, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { CheckIcon, LockIcon } from "lucide-react";
import { AuthCard } from "../../components/auth/AuthCard";
import { PasswordStrength, passwordScore } from "../../components/auth/PasswordStrength";
import { TextField } from "../../components/ui/TextField";
import { BrutalButton } from "../../components/ui/BrutalButton";
import { spring } from "../../utils/motion";
export function ResetPassword() {
  const reduce = useReducedMotion() ?? false;
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [errors, setErrors] = useState<{
    pw?: string;
    confirm?: string;
  }>({});
  const [status, setStatus] = useState<"idle" | "saving" | "done">("idle");
  const submit = (e: FormEvent) => {
    e.preventDefault();
    const next: typeof errors = {};
    if (passwordScore(pw) < 2) next.pw = "Make it a little stronger.";
    if (confirm !== pw) next.confirm = "Passwords don't match.";
    setErrors(next);
    if (Object.keys(next).length) return;
    setStatus("saving");
    window.setTimeout(() => setStatus("done"), 900);
  };
  return <AuthCard title={status === "done" ? "Password updated" : "Choose a new password"} description={status === "done" ? undefined : "Make it one you haven't used here before."} data-id="element-1687" data-mp="27je1my7vos8x">
      <AnimatePresence mode="wait" initial={false} data-id="element-1688" data-mp="23g7xpx88nd5m">
        {status === "done" ? <motion.div key="done" initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={spring.smooth} role="status" data-id="element-1689" data-mp="1yk90dk4xmkt2">
            <motion.span initial={reduce ? false : {
          scale: 0.6
        }} animate={{
          scale: 1
        }} transition={spring.bouncy} className="grid h-14 w-14 place-items-center rounded-full border-3 border-line bg-good text-night" data-id="element-1690" data-mp="1olt9ni9thdk3">
              <CheckIcon className="h-7 w-7" strokeWidth={3} data-id="element-1691" data-mp="3ewxwivac12p7" />
            </motion.span>
            <p className="mt-4 text-[15px] text-ink-2" data-id="element-1692" data-mp="1ca0omxm6otsv">You're all set. Sign in with your new password.</p>
            <div className="mt-6" data-id="element-1693" data-mp="1h1se14tlsthf">
              <BrutalButton to="/auth/signin" full size="lg" data-id="element-1694" data-mp="1h2tr1eu6jq1s">
                Sign in
              </BrutalButton>
            </div>
          </motion.div> : <motion.form key="form" onSubmit={submit} noValidate className="space-y-4" exit={{
        opacity: 0
      }} data-id="element-1695" data-mp="17ao44jisbytg">
            <div data-id="element-1696" data-mp="1v23aqohlh2ai">
              <TextField label="New password" type="password" icon={LockIcon} value={pw} onValueChange={setPw} error={errors.pw} autoComplete="new-password" data-id="element-1697" data-mp="1v1joivkwvrqo" />
              {!errors.pw && <PasswordStrength password={pw} data-id="element-1698" data-mp="1m155k2vf6oqc" />}
            </div>
            <TextField label="Confirm password" type="password" icon={LockIcon} value={confirm} onValueChange={setConfirm} error={errors.confirm} autoComplete="new-password" data-id="element-1699" data-mp="1qzey05prfb89" />
            <BrutalButton type="submit" full size="lg" loading={status === "saving"} data-id="element-1700" data-mp="an9nomd4s1vf">
              {status === "saving" ? "Saving…" : "Update password"}
            </BrutalButton>
          </motion.form>}
      </AnimatePresence>
    </AuthCard>;
}